import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const eventTimeZoneImporterSelectors = importerSelectors(
  'eventTimeZone.importer',
);

export default eventTimeZoneImporterSelectors;
